export const OPERATORS = ['<', '<=', '>', '>=', '==', '!='] as const;

export type Operator = (typeof OPERATORS)[number];

const COMPARATORS: Record<Operator, (value: number, threshold: number) => boolean> = {
  '<': (v, t) => v < t,
  '<=': (v, t) => v <= t,
  '>': (v, t) => v > t,
  '>=': (v, t) => v >= t,
  '==': (v, t) => v === t,
  '!=': (v, t) => v !== t,
};

/** True when `value` satisfies `value <operator> threshold`, i.e. the rule is breached. */
export function compare(value: number, operator: Operator, threshold: number): boolean {
  return COMPARATORS[operator](value, threshold);
}
